"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformObjValues = void 0;
const to_object_1 = require("./sync/to-object");
const utils_1 = require("./utils");
/**
 * Applies a transformation to the value of all pro
 * @param obj The object to be iterated with
 * @param mapper the mapper to be applied to each value
 */
function transformObjValues(obj, mapper) {
    return to_object_1.toObject.call((0, utils_1.iterateObjEntries)(obj), ([p]) => p, mapper);
}
exports.transformObjValues = transformObjValues;
